import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../common/api/request";
import config from "../../config";

// [CANA-856] Driver cash handovers mirrored from Drogo; admin API shape is
// pinned in CANA-857 (same list envelope as /pending-bag-transfers/).
const toRejection = (error, rejectWithValue) => {
  const status = error?.response?.status;
  if (
    error.response &&
    error.response.data &&
    typeof error.response.data === "object"
  ) {
    return rejectWithValue({ ...error.response.data, status });
  }
  return rejectWithValue({ Error: error.message, status });
};

export const getCashHandovers = createAsyncThunk(
  "getCashHandovers",
  async (params = {}, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/cash-handovers/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      return toRejection(error, rejectWithValue);
    }
  }
);

export const confirmCashHandover = createAsyncThunk(
  "confirmCashHandover",
  async ({ id, counted_cash, note }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/cash-handovers/${id}/confirm/`,
        { counted_cash, note },
        config
      );
      return { id, ...(data || {}) };
    } catch (error) {
      return toRejection(error, rejectWithValue);
    }
  }
);

// [CANA-867] Totals for the driver page cards, same filters as the list,
// no pagination (backend CANA-866).
export const getCashHandoversSummary = createAsyncThunk(
  "getCashHandoversSummary",
  async (params = {}, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/cash-handovers/summary/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      return toRejection(error, rejectWithValue);
    }
  }
);
